import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

export default class Product {
  constructor({ el, isLargeQuery }) {
    this.el = el;
    this.isLargeQuery = isLargeQuery;
    this.carouselEl = this.el.querySelector('.carousel .swiper');
    this.currentSlideText = this.el.querySelector('.current-slide');

    // variant picker logic
    this.form = this.el.querySelector('.product-form form');
    this.priceText = document.getElementById('price-text');
    this.submitButton = document.getElementById('submit-button');
    this.currentVariantId = document.getElementById('current_variant_id');
    this.cartCountEls = Array.from(document.querySelectorAll('.cart-count'));
    this.addToCartNotification = document.getElementById('add-to-cart-notification');

    // optionlists. Used to make sure they have made all their selections
    this.optionLists = Array.from(document.querySelectorAll('.option-list'));

    this.init();
  }

  init() {
    if (this.carouselEl) {
      this.carousel = new Swiper(this.carouselEl, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        roundLengths: true,
        breakpoints: {
          1024: {
            slidesPerView: this.carouselEl.dataset.twoUp === 'true' ? 1.99 : 1,
          },
        },
      });

      this.carousel.on('slideChange', () => {
        if (this.currentSlideText) {
          this.currentSlideText.innerHTML = this.carousel.realIndex + 1;
        }
      });

      this.prev = this.el.querySelector('.prev');
      this.next = this.el.querySelector('.next');

      if (this.prev) {
        this.prev.addEventListener('click', () => {
          this.carousel.slidePrev();
        });
      }

      if (this.next) {
        this.next.addEventListener('click', () => {
          this.carousel.slideNext();
        });
      }
    }

    if (this.form) {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();

        // first check if any of the optionlists have no-selection-made class
        const noSelectionMade = this.optionLists.some((optionList) => {
          return optionList.classList.contains('no-selection-made');
        });

        if (noSelectionMade) {
          alert('Please make all your selections before adding to cart.');
          return;
        }

        this.submitButton.innerHTML = 'Adding...';

        const originalFormData = new FormData(this.form);
        const notesObj = {};

        // loop through form data entries to get any notes (default gold and default sizes)
        for (const entry of originalFormData.entries()) {
          // check if entry starts with 'static-option:'
          if (entry[0].startsWith('static-option:')) {
            // if it does, set property in notes object
            notesObj[entry[0].replace('static-option:', '')] = entry[1];
          }
        }

        const formData = {
          items: [
            {
              quantity: parseInt(originalFormData.get('quantity')),
              id: parseInt(originalFormData.get('current_variant_id')),
              properties: notesObj,
            },
          ],
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then(() => {
            this.successCallback();
          })
          .catch((error) => {
            console.log(error);
          });
      });
    }
  }

  successCallback() {
    // track add to cart event for fb
    if (document.body.classList.contains('cookies-accepted')) {
      fbq('track', 'AddToCart');
    }

    fetch('/cart.js')
      .then((response) => response.json())
      .then((data) => {
        // update cart count, submit button
        this.submitButton.innerHTML = 'Add to Cart';
        this.cartCountEls.forEach((el) => {
          el.innerHTML = data.item_count;
        });
        this.addToCartNotification.classList.add('active');
        document.body.classList.remove('hide-nav');

        setTimeout(() => {
          this.addToCartNotification.classList.remove('active');
        }, 2000);
      });
  }

  errorCallback() {
    alert('There was an error adding your item to cart. Please try again.');
    this.submitButton.innerHTML = 'Add to Cart';
  }
}
